module.exports = __webpack_public_path__ + "media/images/chart_big-b77d587ce5115a62004a1088cb24ceeb.png";